import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { ROLES_MODULE } from '../RoleSwitchBar';
import { ErrorPage } from '../SuccessPage/ErrorPage';
import { useAuth } from '../../contexts';

type SSOProtectedRouteProps = {
  role: ROLES_MODULE[];
  children: React.ReactNode;
  redirectPath: string;
};
export const SSOProtectedRoute = (
  props: SSOProtectedRouteProps,
): React.ReactNode => {
  const { redirectPath, children, role: rolesArr } = props;
  const { user, isTokenValid, role: currentRole } = useAuth();
  const location = useLocation();
  const isValid = isTokenValid();

  if (!isValid) {
    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }

  /* 
   1. currentRole === null
   2. currentRole !== null, but not in rolesArr
 */
  const isOutRoles =
    (typeof currentRole === 'string' &&
      !rolesArr.includes(currentRole as ROLES_MODULE)) ||
    !currentRole;

  // for applicants, user?.userInfo?.netId may not exist
  const delegatingSupervisor =
    user?.sub !== user?.userInfo?.netId && Boolean(user?.userInfo?.netId);

  if (isOutRoles && !delegatingSupervisor) {
    return <ErrorPage errorCode={403} />;
  }

  return children;
};
